export default __webpack_public_path__ + "static/media/errorIcon.4c2c2764.svg";